import { render } from "./Compass2.vue?vue&type=template&id=6d8b07b7&scoped=true"
import script from "./Compass2.vue?vue&type=script&lang=js"
export * from "./Compass2.vue?vue&type=script&lang=js"

import "./Compass2.vue?vue&type=style&index=0&id=6d8b07b7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8b07b7"]])

export default __exports__